import React, { Component } from 'react';

// import ArticleSuggestions from '../article-suggestions/article-suggestions';
import DailyNewsSuggestions from '../daily-news-suggestions';
import { localStorage, LocalStorageKeysMapping } from '../../../services/local-storage/local-storage';
import LoadingIndication from '../../common/loading-indicator';
import DailyNewsNavigationBar from './daily-news-navigation-bar';
import shareService from '../../../services/share';
import dailyNewsService from '../../../services/daily-news';
import AnimatedWrapper from '../../core/animated-wrapper';
import TagsBar from '../../common/tags-bar';
import articleTagsService from '../../../services/article-tags/article-tags';
import SmartAd from '../../ads/smart-ad';
import Button from '../../common/button/button';

import './daily-news-article.css';

const readMoreButtonStyles = {
  button: {
    backgroundColor: 'rgba(43, 104, 156, 1)',
    border: 'solid rgba(43, 104, 156, 1) 0px'
  },
  label: {
    textTransform: 'capitalize'
  }
};

class DailyNewsArticle extends Component {
  LocalStorageSeenKey = 'SEEN_DAILY_NEWS';

  constructor(props) {
    super(props);
    
    this.state = {
      isLoading: true
    };   

    this._pullNewsByProps(props);  
  }

  componentDidUpdate(props) {
    // this._pullNewsByProps(props);  
  }

  _pullNewsByProps(props) {
    const newsId = this._getNewsIdByProps(props);
    
    this.setState({
      isLoading: true,
      isError: false,
      _id: newsId
    }); 

    dailyNewsService.getNewsById(newsId)
      .then(news => {
        const relevantTags = articleTagsService.getRelevantRecommendationsTags(news.tags);

        this._signAsSeenInLocalStorage(newsId);

        this.setState({
          isLoading: false,
          isError: false,
          type: '',          
          ...news,
          url: news.url ? `${news.url}?utm_source=dormosheio&utm_campaign=dormosheio` : '',
          relevantTags,
          subscriptionInfo: {
            source: 'Daily-news',
            sourceValue: newsId,
            tags: news.tags,
          },
        }); 

        shareService.setupPage({ 
          title: news.title,
          isTitlePrefixOn: false,
          twitterRefs: news.twitterRefs || [],
          tags: news.twitterTags,
        });             
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isError: true
        });
      });        
  }

  _signAsSeenInLocalStorage(id) {
    const key = `${LocalStorageKeysMapping[this.LocalStorageSeenKey]}_${id}`;
    localStorage.setItem(key, 'true');
  }

  _getNewsIdByProps(props) {
    const lastIndexOfDash = props.match.params.linkId.lastIndexOf('-');
    if (lastIndexOfDash === -1) {
      return -1;
    }
    
    return Number(props.match.params.linkId.slice(lastIndexOfDash + 1));    
  }

  _getWriterAndPublication() {
    const isSame = this.state.writer === this.state.publication;
    if (this.state.writer && this.state.publication && !isSame) {
      return `${this.state.writer}, ${this.state.publication}`;
    }

    return this.state.writer || this.state.publication
  }

  _getImageOrYoutube() {
    if (this.state.type === 'youtube') {
      return (
        <figure className='iframe-container youtube-container'>
          <iframe 
            title={this.state.title}
            width="560" 
            height="315" 
            src={`https://www.youtube.com/embed/${this.state.youtubeId}`} 
            frameBorder="0" 
            allowFullScreen>
          </iframe>              
        </figure>
      );
    }

    return (
      <div className='article-image-container'>
        <a  href={this.state.url || ''} 
            title={this.state.title} 
            alt={this.state.title}
            target='_blank'>
          <img 
            src={this.state.imgUrl} 
            title={this.state.title} 
            alt={this.state.title} />
        </a>
      </div>
    );
  }

  _getParagraphs() {
    const {paragraphs, subscriptionInfo, tags, } = this.state;
    const paragraphsJSX = paragraphs.map((paragraph, i) => 
      <p key={i} dangerouslySetInnerHTML={{__html: paragraph}}></p>
    );

    if (paragraphs && paragraphs.length <= 1) {
      return paragraphsJSX;
    }

    return [
      paragraphsJSX.slice(0, 1),
      <SmartAd 
        key='ad-banner' 
        tags={ tags }
        subscriptionInfo={ subscriptionInfo } 
        isMixAdSubscription={ true } />,
      paragraphsJSX.slice(1)
    ];
  }

  render() {
    if (this.state.isLoading) {
      return (
        <section className='regular-page daily-news-article-container'>
          <LoadingIndication />
        </section>
      );
    }

    if (this.state.isError) {
      return (
        <section className='regular-page daily-news-article-container'>
          <div>Article not found</div>
          {/*<SiteSubscription />          */}
        </section>
      );
    }

    return (
      <section className='regular-page daily-news-article-container'>
        <section className='news-container'>
          <div className='daily-news-navigation-bar-container'>            
            <DailyNewsNavigationBar {...this.state} />
          </div>

          <article className='daily-news-article'>
            { this._getImageOrYoutube() }

            <div className='article-textual-details'>
              <a  href={this.state.url || ''} 
                  title={this.state.title} 
                  alt={this.state.title}
                  target='_blank'>

                <h4>{this.state.title}</h4> 
              </a>      

              <div className='writer-publication'>
                {this._getWriterAndPublication()}
              </div>

              <div className='tags-container'>
                <TagsBar tags={this.state.relevantTags} />
              </div>

              <div className='paragraphs'>
                {this._getParagraphs()}
              </div>

              <div className='little-grow-animation read-more-button-container'>
                <a  href={this.state.url || ''} 
                    title={this.state.title} 
                    alt={this.state.title}
                    target='_blank'>    

                  <Button label="Read More" isDark={ true } />
                </a>
              </div>          
            </div>
          </article>

          { this.state.paragraphs && this.state.paragraphs.length <= 1 && 
            <SmartAd 
              tags={ this.state.tags }
              subscriptionInfo={ this.state.subscriptionInfo } 
              isMixAdSubscription={ true } />
          }

          <SmartAd 
            subscriptionInfo={ this.state.subscriptionInfo } 
            isMixAdSubscription={ true } 
            isOnlySubscriptionPossible={ true } />

          {
            this.state.tags && this.state.tags.length > 0 &&
              <section className='article-suggestions'>
                <DailyNewsSuggestions tag={this.state.tags[0]} />
              </section>
          }

        </section>
      </section>
    );
  }
}

const AnimatedDailyNewsArticle = AnimatedWrapper(DailyNewsArticle);
export default AnimatedDailyNewsArticle;